import { useEffect } from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import { Stack } from '@chakra-ui/react'
import {
  getAdminNotifications,
  getEventMarkers,
  getGuestNotification,
  getUserProfile,
  handleLocationMyPosition,
  logOut,
  setBlogParent,
  setIsProfileActive,
  setOnPostEditor,
  setPosts,
  setPostsTypeStatus,
  setSelectedUserProfile,
  setUpdateUserProfileStatus,
  setUserEdited,
  setUserSectionPage,
  usersSelectors
} from 'store'
import { LoadingSpinier } from 'common/Loading'
import {
  BLOGS,
  EDIT_PROFILE,
  PLATFORM_LIST,
  MY_PROFILES,
  PENDING,
  SETTINGS,
  SIGN_IN,
  SINGLE_PROFILE,
  SUCCEEDED
} from 'utils/constants'
import { isAuth } from 'utils/helpers'

import { ProfileBlog } from 'components/UserSection/ProfileBlog'
import { EditProfile } from 'components/UserSection/EditProfile'
import { MyProfiles } from 'components/UserSection/MyProfiles'
import { Settings } from 'components/UserSection/Settings'
import { SingleProfile } from 'components/UserSection/SingleProfile'
import { SocialProfileSelect } from 'components/UserSection/EditProfile/SocialProfiles/SocialProfileSelect'

export const UserSection = ({
  selectedUser,
  setSelectedUser,
  pageName,
  setSocialLinksArray,
  socialLinksArray,
  setSocialLinkSelected,
  socialLinkSelected
}) => {
  const {
    croppedPicture,
    deleteProfileStatus,
    deleteUserStatus,
    getUserProfileStatus,
    repostThisPostData,
    searchBar,
    selectProfileStatus,
    updateUserProfileStatus,
    updateUserSettingsStatus,
    user,
    userEdited,
    userPosition,
    userProfile
  } = useSelector(usersSelectors)

  const dispatch = useDispatch()

  const handleSelectUser = (item) => {
    setSelectedUser(item)

    if (item.full_name) {
      dispatch(setUserSectionPage(SINGLE_PROFILE))
      dispatch(setIsProfileActive(true))
    } else {
      dispatch(setUserSectionPage(EDIT_PROFILE))
      dispatch(setIsProfileActive(false))
    }
  }

  const handleSelectLocation = (item) => {
    setSelectedUser(item)
    dispatch(setSelectedUserProfile(item))
    dispatch(handleLocationMyPosition(item))
  }

  const handleLogOut = () => {
    localStorage.setItem('recentSearches', '[]')
    dispatch(logOut(true))
    dispatch(getGuestNotification())

    dispatch(setUserSectionPage('clear'))
    setTimeout(() => dispatch(setUserSectionPage(SIGN_IN)), 850)

    const userDrawerBody = document.querySelector('#chakra-modal--body-user-drawer')
    if (userDrawerBody) {
      userDrawerBody.scrollTop = 0
    }
  }

  const handleSection = () => {
    if (pageName === MY_PROFILES) {
      return (
        <MyProfiles
          handleSelectUser={handleSelectUser}
          handleLogOut={handleLogOut}
          isLoading={getUserProfileStatus === PENDING || selectProfileStatus === PENDING}
          user={user}
          userProfile={userProfile}
        />
      )
    }

    if (pageName === SINGLE_PROFILE) {
      return (
        <SingleProfile
          selectedUser={selectedUser}
          setUserSectionPage={setUserSectionPage}
          handleSelectLocation={handleSelectLocation}
          updateUserProfileStatus={updateUserProfileStatus}
        />
      )
    }

    if (pageName === BLOGS) {
      return (
        <ProfileBlog
          selectedUser={selectedUser}
          affinityList={searchBar.affinities}
        />
      )
    }

    if (pageName === EDIT_PROFILE) {
      return (
        <EditProfile
          userPosition={userPosition}
          isLoading={updateUserProfileStatus === PENDING}
          deleteProfileStatus={deleteProfileStatus}
          selectedUser={selectedUser}
          setUserSectionPage={setUserSectionPage}
          croppedPicture={croppedPicture}
          affinityList={searchBar.affinities}
          updateUserProfileStatus={updateUserProfileStatus}
          setSocialLinksArray={setSocialLinksArray}
          socialLinksArray={socialLinksArray}
          setSocialLinkSelected={setSocialLinkSelected}
          socialLinkSelected={socialLinkSelected}
        />
      )
    }

    if (pageName === PLATFORM_LIST) {
      return (
        <SocialProfileSelect
          setSocialLinkSelected={setSocialLinkSelected}
          socialLinksArray={socialLinksArray}
        />
      )
    }

    if (
      pageName === SETTINGS
      && isAuth()
    ) {
      return (
        <Settings
          isLoading={updateUserSettingsStatus === PENDING}
          user={user}
          deleteUserStatus={deleteUserStatus}
        />
      )
    }

    return (
      <Stack
        position="absolute"
        height="100%"
        width="100%"
      >
        <LoadingSpinier />
      </Stack>
    )
  }

  useEffect(() => {
    if (updateUserProfileStatus === SUCCEEDED) {
      dispatch(getAdminNotifications())
      dispatch(getEventMarkers({ isAuth: true }))

      if (userProfile) {
        dispatch(getUserProfile())
        dispatch(setUserSectionPage(null))
        dispatch(setUserSectionPage(SINGLE_PROFILE))

        let drawerContents = document.querySelector(`#${SINGLE_PROFILE}-drawer-body`)
        if (drawerContents) {
          drawerContents.scrollTop = 0
        }

        userProfile.map((item) => {
          if (userEdited.id === item.id) {
            handleSelectUser(item)
            dispatch(setUserEdited([]))
          }

          return null
        })
      }

      dispatch(setUpdateUserProfileStatus(0))
    }
  }, [updateUserProfileStatus])

  useEffect(() => {
    if (Object.keys(repostThisPostData).length) {
      const activeProfile = userProfile.find((item) => item.is_active)

      if (activeProfile) {
        setSelectedUser(activeProfile)
        dispatch(setPostsTypeStatus('posted'))
        dispatch(setPosts([]))
        dispatch(setBlogParent([]))
        dispatch(setOnPostEditor(''))

        setTimeout(() => {
          dispatch(setUserSectionPage(SINGLE_PROFILE))
          dispatch(setUserSectionPage(BLOGS))
        }, 200)
      }
    }
  }, [])

  return (
    <Stack>
      {handleSection()}
    </Stack>
  )
}
